import { Action, createReducer, on } from '@ngrx/store';

import { TokenData } from 'src/app/model/api/token-data';
import * as AuthActions from './auth.actions';

export interface State {
    tokenData?: TokenData;
    loading: boolean;
    resetting: boolean;
    resetted: boolean;
    registrationSuccess: boolean;
    confirmUserAccount: number;  /* 0 -> undefined, 1 -> Failed, 2 -> Success */
    loginMfaCode: number;  /* 0 -> to do login, 1 -> to receive mfa code, 2 -> to insert mfa code, 3 -> error insert mfa code, 4 -> success*/
}
export const initialState: State = {
    loading: false,
    resetting: false,
    resetted: false,
    registrationSuccess: false,
    confirmUserAccount: 0,
    loginMfaCode: 0,
};

const authReducer = createReducer(
    initialState,
    on(AuthActions.getTokenSuccess, (state, payload) => ({ ...state, tokenData: payload.tokenData })),
    on(AuthActions.authLogout, (state) => ({ ...state, tokenData: undefined })),
    on(AuthActions.resetPassword, (state) => ({ ...state, resetting: true, resetted: false })),
    on(AuthActions.resetPasswordSuccess, (state) => ({ ...state, resetting: false, resetted: true })),
    on(AuthActions.resetPasswordFailed, (state) => ({ ...state, resetting: false, resetted: false })),
    on(AuthActions.confirmEmailSuccess, (state) => ({ ...state, confirmUserAccount: 2 })),
    on(AuthActions.confirmEmailFailed, (state) => ({ ...state, confirmUserAccount: 1 })),
    on(AuthActions.confirmEmailReset, (state) => ({ ...state, confirmUserAccount: 0 })),
    on(AuthActions.getHelpToken, (state, payload) => ({ ...state, tokenData: payload.tokenData })),
    on(AuthActions.setUserToken, (state, payload) => ({ ...state, tokenData: payload.tokenData })),
    on(AuthActions.technicianSignupSuccess, (state) => ({ ...state, registrationSuccess: true })),
    on(AuthActions.userSignupSuccess, (state) => ({ ...state, registrationSuccess: true })),
    on(AuthActions.signupReset, (state) => ({ ...state, registrationSuccess: false })),
    //----------------- NEW 2FA Auth
    on(AuthActions.authMfaCode, (state) => ({ ...state, loginMfaCode: 1 })),
    on(AuthActions.authMfaCodeReset, (state) => ({ ...state, loginMfaCode: 0 })),
    on(AuthActions.authMfaCodeInvalidMfaCode, (state) => {
        const loginMfaCode = state.loginMfaCode;
        if (loginMfaCode === 1) {
            return { ...state, loginMfaCode: 2, };
        }
        return { ...state, loginMfaCode: 3, };
    }),
    on(AuthActions.authMfaCodeFailed, (state) => ({ ...state, loginMfaCode: 0 })),
    on(AuthActions.getMfaTokenSuccess, (state, payload) => ({ ...state, tokenData: payload.tokenData, loginMfaCode: 4 })),
    //----------------- NEW 2FA Auth

);

export const reducer = (state: State | undefined, action: Action): State => authReducer(state, action);
